export const wait = (s: number) => new Promise((res) => setTimeout(res, s * 1000));
